import { ReactNode } from 'react'
import { getTaskPriorityEnumByValue } from 'utils'

import { CrewTaskPriorityIcon } from 'components/elements/crewTaskPriorityIcon/crewTaskPriorityIcon'

// SelectBoxのitemRenderに渡すコンポーネント。renderとして使われるのでmemoできない
export const CrewTaskPrioritySelectBoxItemRender = (data: {
  id: number
  name: string
}): ReactNode => {
  const taskPriority = getTaskPriorityEnumByValue(data.id)
  return (
    <div className="dx-texteditor-input p-0 flex items-center gap-2">
      {taskPriority && <CrewTaskPriorityIcon taskPriority={taskPriority} />}
      <span>{data?.name}</span>
    </div>
  )
}
